import React, { useContext, useEffect, useState } from "react";
import Header from "./Comman/Header";
import { OnmaxContext } from "../OnmaxContext";
import axios from "axios";
import Pagination from "./Comman/Pagination";

export default function Staking() {
  const { formatDateTime } = useContext(OnmaxContext);
  const [data, setdata] = useState([]);
  const [isLoading, setisLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [pages, setPages] = useState(1);
  const username = localStorage.getItem("username");

  const getData = React.useCallback(async () => {
    if (!username) {
      return;
    }
    setisLoading(true);

    await axios
      .post(process.env.REACT_APP_BACKEND_LINK, {
        method: "transaction",
        submethod: "getbyid",
        username: username,
        key: process.env.REACT_APP_KEY,
        page: currentPage,
        pageSize: pageSize,

      })
      .then((res) => {
        setisLoading(false);
        if (res.data.error) {
          return "";
        }
        setdata(res.data.data);
        setPages(Math.ceil(res.data.total / pageSize));

      });
  }, [username, currentPage, pageSize]);

  useEffect(() => {
    getData();
  }, [getData]);


  return (
    <>
      <div className="body-bg">
        <Header />
        <section className="nftmax-adashboard nftmax-show mt-4 setting-section">
          <div className="container db-profile-card">
            <div className="row justify-content-center">
              <div className="col-12">

                {/* Card Container - Matching Dashboard Reward Overview Style */}
                <div className="db-profile-card-premium mb-5">

                  <div className="db-sec-hdr">
                    <div className="db-sec-dot"></div>
                    <div className="db-sec-title">Purchase History</div>
                  </div>
                  <div className="card-body p-0">
                    <div className="table-responsive">
                      <table className="table table-dashboard-premium align-middle mb-0" style={{ minWidth: '800px' }}>
                        <thead className="text-uppercase small">
                          <tr>
                            <th scope="col" className="ps-4 py-3" style={{ width: '10%', border: 'none' }}>Sr.</th>
                            <th scope="col" className="py-3" style={{ width: '20%', border: 'none' }}>Staked Amount</th>
                            <th scope="col" className="py-3" style={{ width: '50%', border: 'none' }}>Duration & Reward</th>
                            <th scope="col" className="pe-4 py-3 text-end" style={{ width: '20%', border: 'none' }}>Status</th>
                          </tr>
                        </thead>
                        <tbody>
                          {isLoading && !data.length ? (
                            <tr>
                              <td colSpan="4" className="text-center py-5">
                                <div className="spinner-border text-primary" role="status">
                                  <span className="visually-hidden">Loading...</span>
                                </div>
                              </td>
                            </tr>
                          ) : !data.length ? (
                            <tr>
                              <td colSpan="4" className="text-center py-5 text-slate-400">
                                <p className="mb-0">No transaction data found.</p>
                              </td>
                            </tr>
                          ) : (
                            data.map((ele, i) => {
                              const index = currentPage * pageSize - pageSize + (i + 1);
                              return (
                                <tr key={i} className="table-tr-premium">
                                  <td className="ps-4">
                                    <span className="text-slate-400 small">{index}</span>
                                  </td>

                                  <td>
                                    <div className="d-flex align-items-center">
                                      <div className="bg-soft-primary rounded-circle p-2 me-2 d-flex align-items-center justify-content-center" style={{ width: '32px', height: '32px' }}>
                                        <i className="fa fa-dollar-sign text-xs"></i>
                                      </div>
                                      <span className="fw-bold text-white-custom fs-6">${ele.amount}</span>
                                    </div>
                                  </td>

                                  <td className="py-3">
                                    <div className="d-flex gap-4">
                                      {ele.startdate && (
                                        <div>
                                          <div className="text-slate-400 text-uppercase text-xs fw-bold mb-0">Start</div>
                                          <div className="small">{formatDateTime(ele.startdate)}</div>
                                        </div>
                                      )}
                                     
                                      {ele.nextweekRewardDate && (
                                        <div>
                                          <div className="text-primary text-uppercase text-xs fw-bold mb-0">
                                            Next ROI
                                          </div>
                                          <div className="small fw-semibold">
                                            {(() => {
                                              const date = new Date(ele.nextweekRewardDate);
                                              date.setUTCDate(date.getUTCDate() + 1);
                                              return date.toLocaleDateString("en-GB", {
                                                day: "2-digit",
                                                month: "long",
                                                year: "numeric",
                                                timeZone: "UTC",
                                              });
                                            })()}
                                          </div>
                                        </div>
                                      )}
                                    </div>
                                  </td>

                                  <td className="pe-4 text-end">
                                    {ele.status === true ? (
                                      <span className="badge bg-soft-success rounded-pill px-3 py-2 fw-semibold border border-success border-opacity-10">
                                        Active
                                      </span>
                                    ) : (
                                      <span className="badge bg-soft-danger rounded-pill px-3 py-2 fw-semibold border border-danger border-opacity-10">
                                        Ended
                                      </span>
                                    )}
                                  </td>
                                </tr>
                              );
                            })
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>

                  {/* Card Footer for Pagination */}
                  <div className="card-footer bg-transparent border-top border-secondary border-opacity-10 p-4">
                    <Pagination
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                      pageSize={pageSize}
                      setPageSize={setPageSize}
                      pages={pages}
                    />
                  </div>

                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
